import { useState } from "react";
import { Link } from "react-router-dom";
import ImagesData from "@assets/ImagesData";
import {
    LiaCitySolid,
    IoIosCall,
    IoMailOutline,
    FaFacebookSquare,
    FaInstagram,
    FaYoutube,
    FaWhatsapp,
    FaLinkedinIn,
    BsTwitterX,
} from '@assets/Icons';
import { MdTravelExplore } from "react-icons/md";
import TAEnquiry from "../ta-enquiry";

const Footer = () => {

    const [showTAForm, setShowTAForm] = useState(false);

    return (
        <>
            <div className='footer'>
                <div className='top'>
                    <div className='container'>
                        <div className='row align-items-center'>
                            <div className='col-lg-6 col-md-4 col-sm-12 col-xm-12'>
                                <img src={ImagesData?.Logo2} title='' />
                            </div>
                            <div className='col-lg-6 col-md-8 col-sm-12 col-xm-12'>
                                <div className='d-flex align-items-center float-right'>
                                    <h4 className='mr-3'>Become A Member</h4>
                                    <Link to='/property-enquiry' className='btn btn-default-outline inline-flex align-items-center'>
                                        <LiaCitySolid size={24} className='mr-1' />
                                        List your Hotel
                                    </Link>
                                    <span
                                        className='btn btn-default-outline inline-flex align-items-center ml-1'
                                        onClick={() => setShowTAForm(true)}>
                                        <MdTravelExplore size={24} className='mr-1' />
                                        TA Enquiry
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bottom'>
                    <div className='container'>
                        <div className='row'>
                            <div className='left col-lg-4 col-md-12'>
                                <div className='column pl-0' style={{ border: 'none' }}>
                                    <p className='fs-4 text-gray'>
                                        Download the
                                        <span className='fw-bold'> RROOMS </span>
                                        mobile App now and get
                                        <span className='fw-bold'> upto 30% discount </span> on your first booking
                                        <span className='fw-bold'> Download RROOMS </span>
                                        app for exciting offers.
                                    </p>
                                    <div className='flex mt-3'>
                                        <div className='w-50'>
                                            <a href="https://apps.apple.com/in/app/rrooms-hotel-booking-app/id6477883837" target="_blank"><img src={ImagesData?.AppStore} title='' /></a>
                                            <a href="https://play.google.com/store/apps/details?id=com.rrooms" target="_blank"><img src={ImagesData?.PlayStore} title='' /></a>
                                        </div>
                                        <div className='w-40 pl-4'>
                                            <img src={ImagesData?.Scan1} title='' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='right col-lg-8 col-md-12'>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-4 col-sm-12 col-xm-12'>
                                        <div className='column flex-sm'>
                                            <div className='contact-detail'>
                                                <h4 className='v-center fw-semibold pb-6 pt-2'><IoIosCall size={20} className='text-secondary mr-2' />+91-7377378030</h4>
                                                <h4 className='v-center fw-semibold pb-8'><IoMailOutline size={20} className='text-secondary mr-2' />info@rrooms.in</h4>
                                            </div>
                                            <div className='social-detail'>
                                                <h5 className='pb-5 pt-2'>Stay Connected</h5>
                                                <ul className='social'>
                                                    <li><a href='https://www.facebook.com/RROOMSHospitality/' target="_blank"><FaFacebookSquare /></a></li>
                                                    <li><a href='https://www.instagram.com/rroomshospitality?igsh=NXR0b2VpbzUyNjhm' target="_blank"><FaInstagram /></a></li>
                                                    <li><a href='https://www.youtube.com/channel/UCFZH4rXtrgEl9bBAPy-TtwQ' target="_blank"><FaYoutube /></a></li>
                                                    <li><a href='https://web.whatsapp.com/' target="_blank"><FaWhatsapp /></a></li>
                                                    <li><a href='https://www.linkedin.com/in/social-rrooms-3b0567293/' target="_blank"><FaLinkedinIn /></a></li>
                                                    <li><a href='https://x.com/' target="_blank"><BsTwitterX /></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 col-sm-6 col-xm-6'>
                                        <div className='column'>
                                            <h5>RROOMS</h5>
                                            <ul className='links'>
                                                <li><Link to='/about-us'>About RROOMS</Link></li>
                                                <li><Link to='/career'>Careers</Link></li>
                                                <li><Link to='/how-it-works'>How it works</Link></li>
                                                <li><Link to='/Partnership-program'>Partnership Programs</Link></li>
                                                <li><Link to='/Promotion-events'>Promotion & Events</Link></li>
                                                <li><Link to='/Community'>RROOMS Community</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 col-sm-6 col-xm-6'>
                                        <div className='column'>
                                            <h5>Support</h5>
                                            <ul className='links'>
                                                <li><Link to='/help-center'>Help Center</Link></li>
                                                <li><Link to='/contact'>Contact Us</Link></li>
                                                <li><Link to='/user-agreement'>User Agreement</Link></li>
                                                <li><Link to='/Rrooms-privacy-policy'>Privacy Policy</Link></li>
                                                <li><Link to='/terms-and-conditions'>Terms & Condition</Link></li>
                                                <li><Link to='/cancellation-refund-policy'>Refund & Cancellation Policy</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='copyright'>
                    <div className='container'>
                        <div className='row align-items-center'>
                            <div className='col-lg-8'>
                                <p className='text-light fs-6'>Copyright ©–2025 RROOMS™. All rights reserved.</p>
                            </div>
                            <div className='col-lg-4 text-right'>
                                <img src={ImagesData?.PaymentOptions} className='d-inline-block' title='' alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TAEnquiry showTAForm={showTAForm} setShowTAForm={setShowTAForm} />
        </>
    )
}

export default Footer;